import React, { Component, Children, cloneElement } from 'react';
// import { slide as Menu } from 'react-burger-menu';
// import { Link } from 'react-router-dom';
// import Radium from 'radium';
import Helmet from 'react-helmet';

// import LeftMenu from './LeftMenu';

// const RadiumLink = Radium(Link);

export default class App extends Component {
  constructor(props) {
    super(props);
    this.displayName = 'App';
    this.state = {
      menuIsOpen: false,
    };
    this.handleMenuStateChange = this.handleMenuStateChange.bind(this);
  }

  handleShowMenu() {
    this.setState({ menuIsVisible: true });
  }

  handleHideMenu() {
    this.setState({ menuIsVisible: false });
  }

  handleMenuStateChange({ isOpen }) {
    this.setState({ menuIsOpen: isOpen });
  }

  renderMenu() {
    const { menuIsOpen, menuIsVisible } = this.state;
    // return menuIsVisible ? (
    // return (
    //   <LeftMenu onStateChange={this.handleMenuStateChange} />
    // );
    // ) : null;
  }

  render() {
    return (
      <div id="outer-container" className={this.state.menuIsOpen ? 'menu-open' : ''}>
        <Helmet
          title="Compendium of Charts"
          titleTemplate="%s | Number Picture"
          link={[
            {
              rel: 'apple-touch-icon',
              sizes: '57x57',
              href: '/assets/images/favicon/apple-icon-57x57.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '60x60',
              href: '/assets/images/favicon/apple-icon-60x60.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '72x72',
              href: '/assets/images/favicon/apple-icon-72x72.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '76x76',
              href: '/assets/images/favicon/apple-icon-76x76.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '114x114',
              href: '/assets/images/favicon/apple-icon-114x114.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '120x120',
              href: '/assets/images/favicon/apple-icon-120x120.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '144x144',
              href: '/assets/images/favicon/apple-icon-144x144.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '152x152',
              href: '/assets/images/favicon/apple-icon-152x152.png',
            },
            {
              rel: 'apple-touch-icon',
              sizes: '180x180',
              href: '/assets/images/favicon/apple-icon-180x180.png',
            },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '192x192',
              href: '/assets/images/favicon/android-icon-192x192.png',
            },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '32x32',
              href: '/assets/images/favicon/favicon-32x32.png',
            },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '96x96',
              href: '/assets/images/favicon/favicon-96x96.png',
            },
            {
              rel: 'icon',
              type: 'image/png',
              sizes: '16x16',
              href: '/assets/images/favicon/favicon-16x16.png',
            },
            {
              rel: 'manifest',
              href: '/assets/images/favicon/manifest.json',
            },
          ]}
          meta={[
            {
              name: 'msapplication-TileColor',
              content: '#ffffff',
            },
            {
              name: 'msapplication-TileImage',
              content: '/assets/images/favicon/ms-icon-144x144.png',
            },
            {
              name: 'theme-color',
              content: '#ffffff',
            },
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0',
            },
            {
              name: 'language',
              content: 'english',
            },
            {
              httpEquiv: 'content-type',
              content: 'text/html',
            },
            {
              name: 'description',
              content: 'React components for building visualizations',
            },
            {
              name: 'robots',
              content: 'index,follow',
            },
            {
              name: 'revisit-after',
              content: '7 days',
            },
            {
              name: 'distribution',
              content: 'web',
            },
            {
              httpEquiv: 'refresh',
              content: '',
            },
            {
              name: 'robots',
              content: 'noodp',
            },
            {
              name: 'format-detection',
              content: 'telephone=yes',
            },
            {
              name: 'HandheldFriendly',
              content: 'true',
            },
            {
              httpEquiv: 'Content-Style-Type',
              content: 'text/css',
            },
            {
              httpEquiv: 'Content-Script-Type',
              content: 'text/javascript',
            },
            {
              property: 'fb:app_id',
              content: '121842931345467',
            },
            {
              property: 'og:url',
              content: 'http://numberpicture.com',
            },
            {
              property: 'og:title',
              content: 'Number Picture - Visual Compendium of Charts',
            },
            {
              property: 'og:description',
              content: 'A book that catalogues over 450 types of charts + a charting library for drawing each one + a website showcasing examples.',
            },
            {
              property: 'og:image',
              content: 'http://numberpicture.com/assets/images/social/fb.jpg',
            },
            {
              name: 'twitter:card',
              content: 'summary_large_image',
            },
            {
              name: 'twitter:title',
              content: 'Number Picture - Visual Compendium of Charts',
            },
            {
              name: 'twitter:description',
              content: 'A book that catalogues over 450 types of charts + a charting library for drawing each one + a website showcasing examples.',
            },
            {
              name: 'twitter:image',
              content: 'http://numberpicture.com/assets/images/social/fb.jpg',
            },
          ]}
        />
        {this.renderMenu()}
        <main id="page-wrap">
          {Children.map(this.props.children, child =>
            cloneElement(child, {
              onHideMenu: this.handleHideMenu.bind(this),
              onShowMenu: this.handleShowMenu.bind(this),
            }),
          )}
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js